import Cookies from 'js-cookie'

import { axiosPublic } from '../../services/api/api'

import { headers } from './util'

interface RefreshToken {
    grant_type: string
    refresh_token: string | undefined
}

export const handleRefreshTokenRequest = () => {
    const request: RefreshToken = {
        grant_type: 'refresh_token',
        refresh_token: Cookies.get('refresh_token'),
    }

    return axiosPublic.post('oauth/access_token', request, {
        headers,
    })
}
